<template>
    <section class="grid-flex column">
      <div class="box w100">
        <div class="box-title flex between middle">
          Descubra quanto você precisa cobrar pelo produto
        </div>
        <div class="box-content">
          <form autocomplete="off" class="w100">
              <div class="flex-1 w100 margin-top-m">
                <label>Custo do produto:</label>
                <money v-model="productCost" v-bind="money"></money>
              </div>
            </form>
          <div class="margin-top-l">
            <p>Preencha o custo do produto no fornecedor que vamos te informar os valores que vale apena vender o produto. Um preço muito baixo de venda pode fazer você ficar devendo dinheiro!</p>
          </div>

          <div class="margin-top-l">
            <p>Os valores abaixo são referentes a <b>1</b> venda do produto que você colocou o custo em vários cenários de valores de venda.</p>
          </div>

          <div class="mytable flex column margin-top-l w100">
            <div class="flex-1 flex w100" style="margin-bottom: 16px">
              <div class="flex-1 center"><b>Markup</b></div>
              <div class="flex-1 center"><b>Valor de venda</b></div>
              <div class="flex-1 center"><b>Custo Marketing (CPA)</b></div>
              <div class="flex-1 center"><b>Imposto (16%)</b></div>
              <div class="flex-1 center"><b>Lucro por Venda</b></div>
              <div class="flex-1 center"><b>Margem de lucro</b></div>
            </div>

            <div
              v-for="(m, index) in [1.5,2,2.5,3,3.5,4,4.5,5]"
              :key="index"
              class="flex-1 flex w100"
              style="padding:10px; border-bottom: 1px solid rgba(0, 0, 0, 0.11)"
              :class="{ red: m < 2 || m >= 4, yellow: m == 3.5, green: m >= 2 && m <= 3.5 }"
            >
              <div class="flex-1">{{ m | number }}x</div>
              <div class="flex-1">{{ productCost * m | money }} </div>
              <div class="flex-1">{{ (productCost * m) * 0.30 | money }}</div>
              <div class="flex-1">{{ calculateImpost(m) | money }}</div>
              <div class="flex-1">{{ calculateProfit(m) | money }} </div>
              <div class="flex-1">{{ calculatePercentProfit(m) | number }}%</div>
            </div>
          </div>

          <div class="margin-top-l flex row middle">
            <h4>Projeção de vendas por Markup:</h4>
            <div class="" style="margin-left: 16px;max-width: 100px">
              <!-- <label>Selecione o Markup:</label> -->
              <select  class="input" v-model="selectedMarkup">
                <option value="1.5">1,5x</option>
                <option value="2" selected>2x</option>
                <option value="2.5">2,5x</option>
                <option value="3">3x</option>
                <option value="3.5">3,5x</option>
                <option value="4">4x</option>
                <option value="4.5">4,5x</option>
                <option value="5">5x</option>
              </select>
            </div>
          </div>
          <div class="mytable flex column margin-top-l w100">
            <div class="flex-1 flex w100" style="margin-bottom: 16px">
              <div class="flex-1 center"><b>Vendas</b></div>
              <div class="flex-1 center"><b>Vendas (Dia)</b></div>
              <div class="flex-1 center"><b>Faturamento</b></div>
              <div class="flex-1 center"><b>Custo Marketing</b></div>
              <div class="flex-1 center"><b>C. Marketing (Dia)</b></div>
              <div class="flex-1 center"><b>Imposto (16%)</b></div>
              <div class="flex-1 center"><b>Lucro</b></div>
            </div>

            <div v-for="(m, index) in [100,500,1000,2000,5000, 10000, 20000]" :key="index" class="flex-1 flex w100" style="padding:10px; border-bottom: 1px solid rgba(238, 236, 236, 0.44)">
              <div class="flex-1">{{ m | number }}</div>
              <div class="flex-1">{{ m / 30 | number }}</div>
              <div class="flex-1">{{ (productCost * selectedMarkup) * m | money }} </div>
              <div class="flex-1">{{ (productCost * selectedMarkup) * 0.30 * m | money }}</div>
              <div class="flex-1">{{ ((productCost * selectedMarkup) * 0.30 * m)  / 30 | money }}</div>
              <div class="flex-1">{{ calculateImpost(selectedMarkup) * m | money }}</div>
              <div class="flex-1">{{ calculateProfit(selectedMarkup) * m | money }} </div>
            </div>
          </div>
        </div>
      </div>




    </section>
</template>

<script>

import { Money } from 'v-money'

export default {
  name: "calculate-product",
  components: {
    Money
  },
  data() {
    return {
      productCost: 0,
      selectedMarkup: 2,
    };
  },
  mounted() {

  },
  methods: {
    calculateImpost(markup) {
      return ((this.productCost * markup) - ((this.productCost * markup) * 0.30) - this.productCost) * 0.16
    },
    calculateProfit(markup) {
      return (this.productCost * markup) - ((this.productCost * markup) * 0.30) - this.productCost - this.calculateImpost(markup)
    },
    calculatePercentProfit(markup) {
      return ((this.productCost * markup) - ((this.productCost * markup) * 0.30) - this.productCost - this.calculateImpost(markup))  / (this.productCost * markup) * 100
    }
  }

}
</script>

<style lang="scss" scoped>
.mytable {
  padding: 15px;
  border: 1px solid #c2c2c24d;
  border-radius: 5px;
}
.red {
  background: #ff000038;
}

.green {
  background: #68ff0038;
}

.yellow {
  background: #ffd70070;
}
</style>
